import React, { Component } from "react";
import swal from "@sweetalert/with-react";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import PermissionModal from "../../Forms/ShortCutComponents/PermissionModal";
import { checkPermission, checkForTireView } from "../../../Helper";
import Select from "react-select";
import ModifierAttach from "./../../POS/orderModifiers/components/modifierAttach";
import "../Floor/myReactSelect.css";
// import "../";
import NumberFormat from "react-number-format";
import { Button, Col, Form } from "reactstrap";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import "../Floor/formsTable.css";
import { Modal } from "react-bootstrap";
import "../Floor/baseForms.css";
import axios from "axios";
import { baseurl } from "../../../baseurl";
var thisContex;
var token = localStorage.getItem("token");
var username = localStorage.getItem("username");
function indexN(cell, row, enumObject, index) {
  return <div>{index + 1}</div>;
}
let companyId = localStorage.getItem("companyId");
class OrderModifierOv extends Component {
  constructor(props) {
    super(props);

    this.toggleAddNew = this.toggleAddNew.bind(this);

    this.hsandleChange = this.handleChange.bind(this);
    this.handleChangeEdit = this.handleChangeEdit.bind(this);

    ////////////////////////

    this.addToggle = this.addToggle.bind(this);

    // this.table = data.rows;
    this.state = {
      showModalAddNew: false,
      data: [],
      govtDesc: "",
      govtDescE: "",
      id: "",
      permission: true,
      rolesPermission: false,
      itemAdd: "",
      showModalOpen: false,
      showItemForm: false,
      tableData: [],
      isLoadedTableData: false,
      defaultSalesTaxOptions: [],
      defaultQuanShow: "0",
      defaultRateShow: "0",
      activity: props?.propData?.location?.rowData?.referencePk,
    };
    thisContex = this;
  }
  showUpdateModal = (cell, row) => {
    this.setState({
      showItemForm: !this.state.showItemForm,
      row_id: row.ITEM_ID,
      updateCheck: 1,
    });
    this.updateModalToggle();
  };
  updateModalToggle = () => {
    this.setState({
      UpdateModal: !this.state.UpdateModal,
    });
  };
  itemLoad = () => {
    this.setState({
      row_id: "-1",
      showItemForm: !this.state.showItemForm,
    });
    this.getData();
    // this.getLovsLoad();
  };
  setDelete = (row) => {
    let rowId = row.ITEM_ID;
    let tempThis = this;
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .post(
            `${baseurl}/masterData/deleteItem`,
            { DeleteId: rowId, username: username, companyId: companyId },
            {
              headers: {
                authorization: token,
              },
            }
          )
          .then((response) => {
            Swal.fire("Deleted!", "Your Record has been deleted.", "success");
            tempThis.getData();
          })
          .catch((err) => {
            console.log(err);
            swal({
              title: "Failed!",
              text: "Internet Problem",
              icon: "error",
              button: "Try Again!",
            });
          });
      }
    });
  };
  nameAndDescription = (cell, row, enumObject, index) => {
    return (
      <div>
        <h5>{row.ITEM_DESC}</h5>
        <p>{row.item_details}</p>
      </div>
    );
  };
  orderDetHandler = (cell, row) => {
    const { rolesPermission } = this.state;
    return (
      <div>
        <span>
          <Button
            className="mr-1"
            size="sm"
            title="Preview"
            // onClick={() => {
            //   this.redirectToOrder("view", row);
            // }}
          >
            <i className="fa fa-eye"></i>
          </Button>
        </span>
        <span>
          <Button
            style={{ margin: "3px" }}
            type="submit"
            size="sm"
            color="primary"
            disabled={rolesPermission}
            onClick={() => this.showUpdateModal(cell, row)}
          >
            Edit
          </Button>
        </span>
        <span>
          <Button
            style={{ margin: "3px" }}
            type="submit"
            size="sm"
            color="danger"
            onClick={() => this.setDelete(row)}
            disabled={rolesPermission}
          >
            Delete
          </Button>
        </span>
        <span>
          <Button
            style={{ margin: "3px" }}
            type="submit"
            size="sm"
            color="warning"
            onClick={() => this.itemLoad()}
            disabled={rolesPermission}
          >
            Attach
          </Button>
        </span>

        <span></span>
      </div>
    );
  };
  toggleAddNew = () => {
    this.setState({
      showItemForm: !this.state.showItemForm,
    });
    // this.setState({ showModalAddNew: !this.state.showModalAddNew });
  };
  toggleOpen = () => {
    this.setState({ showModalOpen: !this.state.showModalOpen });
  };
  handleChange(event) {
    this.setState({
      // Computed property names
      // keys of the objects are computed dynamically
      [event.target.name]: event.target.value,
    });
  }
  handleChangeEdit(event) {
    this.setState({
      [event.target.name]: event.target.value,
    });
  }

  addToggle = () => {
    this.setState({
      itemAdd: "",
    });
    this.toggleAddNew();
  };
  showDetailsModel = (cell) => {
    this.toggleOpen();
  };
  async componentDidMount() {
    await this.asyncRollCheck();
    if (this.state.permission) this.getData();
  }
  asyncRollCheck = async () => {
    let rolId = 3;
    let adminRoleId = 1;
    let readYn = 1;
    let writeYn = 0;
    let formType = "OverView";

    let empId = localStorage.getItem("employeeId");
    let makeTrueFlase = "";
    //ye localStorage se lani h login k wqt
    let permissionFunction = await checkPermission(
      empId,
      adminRoleId,
      rolId,
      readYn,
      writeYn,
      formType
    );
    //permission = permission[0];
    console.log(
      "permissionFunction ",
      permissionFunction[0],
      " ",
      permissionFunction[1],
      " ",
      permissionFunction[2]
    );
    if (permissionFunction[1] == 1 && permissionFunction[2] == 0) {
      makeTrueFlase = true;
    } else {
      makeTrueFlase = false;
    }

    // console.log("a", a);
    this.setState({
      permission: permissionFunction[0],
      rolesPermission: makeTrueFlase,
      //showPermissionModal: false,
      //showPermissionModal: permission ? false : true,
    });
  };
  getData() {
    axios
      .post(
        `${baseurl}/pointOfSale/getOrderModifier`,
        { companyId: companyId, username: username },
        {
          headers: {
            authorization: token,
          },
        }
      )
      .then((res) => {
        // console.log(res.data.data);
        let getItemData = res.data.data;
        //Storing users detail in state array object
        this.setState({
          isLoadedTableData: true,
          tableData: getItemData,
        });
      })
      .catch((err) => {
        console.log(err);
      });
    // axios
    //   .post(
    //     `${baseurl}/lovs/getItem`,
    //     { companyId: companyId, username: username },
    //     {
    //       headers: {
    //         authorization: token,
    //       },
    //     }
    //   )
    //   .then((res) => {
    //     // console.log(res.data.data);
    //     let getItemData = res.data.data;
    //     //Storing users detail in state array object
    //     this.setState({
    //       isLoadedTableData: true,
    //       tableData: getItemData,
    //     });
    //   })
    //   .catch((err) => {
    //     console.log(err);
    //   });
  }
  handleChangeLovsSelect = (defaultSalesTax) => {
    console.log(defaultSalesTax);
    this.setState({
      defaultSalesTax,
      // customerName: customer_id?.label,
      // customerEmail: customer_id?.email,
    });
  };
  handleChangeLovsSelectUom = (uom) => {
    console.log(uom);
    this.setState({
      uom,
    });
  };
  handleChangeLovsSelectUomE = (uomE) => {
    console.log(uomE);
    this.setState({
      uomE,
    });
  };
  handleChangeLovsSelectItemType = (itemType) => {
    console.log(itemType);
    this.setState({
      itemType,
    });
  };
  handleChangeLovsSelectItemTypeE = (itemTypeE) => {
    console.log(itemTypeE);
    this.setState({
      itemTypeE,
    });
  };
  render() {
    const { tableData, showItemForm, isLoadedTableData } = this.state;

    const options = {
      paginationShowsTotal: true,
      page: 1,
      sizePerPage: 5,
      pageStartIndex: 1,
      paginationSize: 5,
      prePage: "Prev",
      nextPage: "Next",
      firstPage: "First",
      lastPage: "Last",
      prePageTitle: "Go to previous",
      nextPageTitle: "Go to next",
      firstPageTitle: "Go to first",
      lastPageTitle: "Go to Last",
      paginationPosition: "top",
      sizePerPageList: [
        {
          text: "10",
          value: 10,
        },
        {
          text: "20",
          value: 20,
        },
        {
          text: "30",
          value: 30,
        },
        {
          text: "All",
          value: tableData.length,
        },
      ],
    };
    if (!this.state.permission) {
      return <PermissionModal moduleName="Purchase" />;
    } else
      return (
        <div className="animated fadeIn">
          <div className="O-V-heading-bar">
            <div className="col-xs-8 col-md-6 mt-2">
              <strong>
                <h4>Order Modifiers Overview </h4>
              </strong>
            </div>

            <div className="col-xs-4 col-md-6 mt-1">
              <div>
                <Link to="/OverviewClient" className="float-right mt-2">
                  <u className="Back-to-Overview text-dark">
                    Back to Client Overview
                  </u>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    fill="currentColor"
                    color="black"
                    className="bi bi-chevron-left mx-2 "
                    viewBox="0 0 16 16"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"
                    />
                  </svg>
                </Link>
              </div>
            </div>
          </div>

          <div className="animated fadeIn">
            <div className="rowStyling mt-1">
              <Col>
                <span
                  style={{
                    textAlign: "right",
                    padding: "6px",
                    float: "right",
                  }}
                >
                  <button
                    class="btn btn-outline-success rounded-pill "
                    disabled={this.state.rolesPermission}
                    onClick={() => this.itemLoad()}
                  >
                    <i class="fa fa-plus pr-2 " aria-hidden="true" />
                    Add New Item
                  </button>
                </span>
                <div>
                  {/* my main data table loaded after my 1st call by function of did mount getLeaveApplicationMain*/}
                  <div translate="no">
                    {isLoadedTableData ? (
                      <BootstrapTable
                        data={tableData}
                        striped
                        pagination
                        hover
                        search
                        tableHeaderClass="rpr_header"
                        tableBodyClass="rpr_body"
                        containerClass="rpr_container"
                        options={options}
                      >
                        <TableHeaderColumn
                          // dataField="GOVT_DEPT_ID"
                          dataAlign="center"
                          dataFormat={indexN}
                          dataSort={true}
                          width="10%"
                        >
                          SR NO #
                        </TableHeaderColumn>
                        <TableHeaderColumn
                          dataField="ITEM_DESC"
                          dataAlign="left"
                          dataFormat={this.nameAndDescription}
                          dataSort={true}
                          width="55%"
                          isKey={true}
                        >
                          Item Name
                        </TableHeaderColumn>
                        <TableHeaderColumn
                          dataField="attachment"
                          dataAlign="center"
                          width="10%"
                          // isKey={true}
                        >
                          Items
                        </TableHeaderColumn>

                        <TableHeaderColumn
                          dataAlign="center"
                          dataField="ITEM_ID"
                          width="10%"
                          dataFormat={this.orderDetHandler}
                        >
                          Action
                        </TableHeaderColumn>
                      </BootstrapTable>
                    ) : (
                      " Loading..."
                    )}
                  </div>
                </div>
              </Col>
            </div>
          </div>

          {/* model calls on Add New Button to input data for submit data */}
          {showItemForm ? (
            <>
              <ModifierAttach
                toggle={this.itemLoad}
                EditData={this.state.row_id}
              />
            </>
          ) : null}
        </div>
      );
  }
}
export default OrderModifierOv;
